import React, { useEffect, useState } from "react";

/**
 * El tema base del sistema es oscuro, asi que este interruptor ofrece la
 * variante clara para jornadas largas de captura de datos.
 *
 * Aplica la clase `tema-claro` al body, que es la que invierte los tokens
 * en src/estilos/sistema-diseno.css. De paso retira la clase `dark-mode`
 * de AdminLTE que pudo quedar guardada por la version anterior del
 * interruptor, porque sus estilos chocarian con el tema.
 */
const ModoOscuro = () => {
    const [temaClaro, setTemaClaro] = useState(false);

    useEffect(() => {
        // Limpieza del estado heredado del interruptor anterior.
        document.body.classList.remove("dark-mode");
        localStorage.removeItem("darkMode");

        const guardado = localStorage.getItem("temaClaro") === "true";
        setTemaClaro(guardado);
        document.body.classList.toggle("tema-claro", guardado);
    }, []);

    const handleToggle = () => {
        const nuevo = !temaClaro;
        setTemaClaro(nuevo);
        document.body.classList.toggle("tema-claro", nuevo);
        localStorage.setItem("temaClaro", nuevo);
    };

    return (
        <button
            type="button"
            className="nav-link btn btn-link"
            onClick={handleToggle}
            title={temaClaro ? "Cambiar a tema oscuro" : "Cambiar a tema claro"}
            aria-label={temaClaro ? "Cambiar a tema oscuro" : "Cambiar a tema claro"}
        >
            <i className={`fas ${temaClaro ? "fa-moon" : "fa-sun"}`}></i>
        </button>
    );
};

export default ModoOscuro;
